import { EventDateTime } from '@/components/EventDetails/EventDateTime/EventDateTime';
import { useAppContext } from '@/components/_shared/context/AppContext';
import { useBasicInfo } from '@/components/_shared/contexts/BasicInfoContext';

export const ConversionBarEventDateTime: React.FC = () => {
  const { data } = useAppContext();
  const { startDate, endDate, isOnline, isSeries, hideStartDate, hideEndDate } = useBasicInfo();

  const shouldShowDateTime = !!startDate?.utc;

  if (!shouldShowDateTime || !startDate) {
    return null;
  }

  return (
    <EventDateTime
      startDate={startDate}
      endDate={endDate ?? { utc: null, timezone: undefined }}
      locale={data.locale}
      isOnlineEvent={isOnline || false}
      isRecurringEvent={isSeries || false}
      hideStartDate={hideStartDate}
      hideEndDate={hideEndDate}
    />
  );
};
